import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CountriesLocationsComponents } from './countries-locations.components';

export const CountriesLocationsRoute: Routes = [
    {
        path: '',
        component: CountriesLocationsComponents,
    },
];